export default "__VITE_ASSET__D2qg24QW__"